import { url } from '../constants/url';
import { UrlDetails, UrlSubTree, UrlTree } from '../types/url';

export default function getUrlPath(targetIdOrObject: string | UrlSubTree): string | undefined {
  const result: (UrlSubTree | UrlDetails)[] = [];

  const id = typeof targetIdOrObject === 'string' ? targetIdOrObject : targetIdOrObject.id;

  const helper = (
    currentNode: UrlSubTree | UrlDetails,
    parents: (UrlSubTree | UrlDetails)[],
  ): boolean => {
    if (currentNode.id === id) {
      result.push(...parents, currentNode);
      return true;
    }

    if ('subPath' in currentNode && currentNode.subPath) {
      for (const key in currentNode.subPath) {
        const subNode = currentNode.subPath[key];
        if (helper(subNode, [...parents, currentNode])) {
          return true;
        }
      }
    }

    return false;
  };

  for (const key in url) {
    const found = helper((url as UrlTree)[key], []);
    if (found) {
      break;
    }
  }

  if (result.length === 0) {
    return;
  }

  const lastResult = result[result.length - 1];
  if (lastResult && 'type' in lastResult && lastResult.type === 'external') {
    return (lastResult as UrlDetails).path;
  } else {
    let path = '';
    result.forEach((e) => {
      if (typeof e.path === 'string' && e.path !== '') {
        path += '/' + e.path;
      }
    });
    return path;
  }
}
